import React from 'react';

const CardItem = ({title, children}:{title:String, children:any}) => {
  return (
    <div className="card">
      <div className="card-header">{title}</div>
      <div className="card-body">
        {children}
      </div>
    </div>
  );
};

export default CardItem;
